import { Button, Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ContentSection } from './styles';
import { listMobileHeaderVacationImage } from 'config/imageUrls';

export const WhatAllura = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <img src={listMobileHeaderVacationImage} width="100%" />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography mb={2}>
              Since 1997, alluraDirect has been the booking source for hundreds-of-thousands of guests who have enjoyed a mountain vacation getaway in Whistler, Big White and Sun Peaks.
            </Typography>
            <Typography mb={2}>
              alluraDirect is a locally owned company (Vancouver, BC) that is focussed on Canadian ski resort vacation
              rentals.  With 25+ years in business, we provide property hosts, managers and guests a safe and secure booking platform for vacation rentals.
            </Typography>
            <Typography mb={1}>
              <strong>Lower Service Fees:</strong> Book with the same great hosts and managers, but save up to 50% on service fees compared to other platforms for the exact same property.
            </Typography>
            <Typography mb={1}>
              <strong>Standard Processes:</strong> The short-term rental business is similar across all the major platforms, VRBO, airBNB and alluraDirect.  If you have booked a vacation rental in the past, there will be no surprises.
            </Typography>
            <Typography mb={2}>
              Our focus on mountain resort destinations has given us the advantage of understanding the communities, businesses and people that make everything great. The global corporations simply cannot achieve this same level of personal connection.
            </Typography>
            <Button size="large" variant="contained" color="secondary" fullWidth href="https://www.alluradirect.com/bigwhite-accommodations.cfm" target="_blank" endIcon={<ChevronRightIcon />}>
              View Big White Accommodation
            </Button>
          </Grid>


        </Grid>
      </ContentSection>
    </>
  );
};
